import {NfGlobalMessage} from "../NfGlobalMessage";
import {NfMessage, NfMessageType} from "../NfMessage";
import type {GetRoomStandards} from "./GetRoomStandards";
import type {RoomStandardDescriptionModel} from "../Models/RoomStandardDescriptionModel";

/**
 * Dane standardów, od service workera
 */
export class RoomStandardData extends NfGlobalMessage {
    public roomStandardsRequest: GetRoomStandards = {} as GetRoomStandards;
    public roomStandardsData: RoomStandardDescriptionModel[]  = [] as RoomStandardDescriptionModel[];
    public languageId: number = 1;

    public constructor(roomStandardsRequest: GetRoomStandards|MessageEvent<RoomStandardData>,
                       roomStandardsData?: RoomStandardDescriptionModel[],
                       languageId?: number
    ) {
        super(NfMessageType.RoomStandardData, arguments.length > 1);
        if(NfMessage.isMessageEvent(roomStandardsRequest)) {
            Object.assign(this, roomStandardsRequest.data);
        } else {
            if(!roomStandardsRequest) {
                throw Error('roomStandardsRequest jest wymagany');
            }
            this.roomStandardsRequest = roomStandardsRequest;

            if(!roomStandardsData) {
                throw Error('roomStandardsData jest wymagany');
            }
            this.roomStandardsData = roomStandardsData;
            if(languageId)
                this.languageId = languageId;
        }
    }
}
NfMessage.creationCallbacks[NfMessageType.RoomStandardData] = (event) => {
    return new RoomStandardData(event);
}
